module.exports = __webpack_public_path__ + "static/media/screenshot_calliope.e6341136.png";